<template>
    <Layout is-crm content-class="customers-invites-page">
        <header class="page__top">
            <h1 v-t="'crm.customers.invites.title'"></h1>
            <div class="customers-invites-page__toolbar"></div>
        </header>
        <PaginatedResource
            ref="customerInvitesRes"
            :fetch-method="fetchCustomersInvites"
            :filter-fields="filtersFields"
            :sorting-fields="sortingFields"
        >
            <template
                #default="{
                    loading,
                    sort,
                    search,
                    filter,
                    canLoadMore,
                    resource,
                    isEmpty,
                    notFound,
                    filters,
                    loadMore,
                }"
            >
                <div class="customers-invites-page__resource">
                    <Spinner v-if="loading" />
                    <CustomersInvitesFilter
                        :statuses="statuses"
                        :filters="filters"
                        @search="search"
                        @filter="filter"
                    />
                    <table class="control-table users-table">
                        <thead class="control-table__head">
                            <tr class="control-table__row">
                                <th class="control-table__cell">
                                    <div class="control-table__cell-inner">
                                        <span v-t="'E-mail'" />
                                        <TableSorting
                                            v-if="sortingFields.includes('email')"
                                            v-model="ordering"
                                            field="email"
                                            @update:model-value="sort(ordering)"
                                        />
                                    </div>
                                </th>
                                <th class="control-table__cell">Status</th>
                                <th
                                    class="control-table__cell control-table__cell--right"
                                    style="width: 400px"
                                >
                                    &nbsp;
                                </th>
                            </tr>
                        </thead>
                        <tbody class="control-table__body">
                            <tr v-if="!loading && (isEmpty || notFound)" class="table__row">
                                <td
                                    class="table__cell table__cell--centered table__empty"
                                    colspan="3"
                                >
                                    <span v-t="'crm.customers.invites.results.noData'" />
                                </td>
                            </tr>
                            <tr v-for="item in resource" :key="item.id" class="control-table__row">
                                <td class="control-table__cell">
                                    <span v-text="item.email" />
                                </td>
                                <td class="control-table__cell">
                                    <span v-text="item.status" />
                                </td>
                                <td class="control-table__cell">
                                    <div class="customers-invites-page__actions">
                                        <CustomersInvitesCopyLink
                                            v-if="item.invite_link"
                                            :link="item.invite_link"
                                        />
                                        <CustomersInvitesAcceptToJoin
                                            v-if="0"
                                            :id="item.id"
                                            @confirmed="refetch"
                                        />
                                        <CustomersInvitesDelete
                                            :id="item.id"
                                            @confirmed="refetch"
                                        />
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div v-if="canLoadMore" class="customers-invites-page__loadmore">
                        <button
                            v-t="'misc.loadmore'"
                            class="button button--big button--blank"
                            type="button"
                            @click="loadMore"
                        />
                    </div>
                </div>
            </template>
        </PaginatedResource>
    </Layout>
</template>

<script>
import { fetchCustomersInvites, fetchCustomersInviteStatuses } from '../../api/customers';
import {
    CustomersInvitesAcceptToJoin,
    CustomersInvitesDelete,
    CustomersInvitesCopyLink,
    CustomersInvitesFilter,
} from '../../components';
import Layout from '@speechki-frontend/shared/ui/layout/Layout';
import PaginatedResource from '@speechki-frontend/shared/PaginatedResource';
import TableSorting from '@speechki-frontend/shared/ui/TableSorting';

import { mapGetters } from 'vuex';

export default {
    name: 'CustomersInvitesPage',
    components: {
        Layout,
        PaginatedResource,
        TableSorting,
        CustomersInvitesAcceptToJoin,
        CustomersInvitesDelete,
        CustomersInvitesCopyLink,
        CustomersInvitesFilter,
    },
    data() {
        return {
            sortingFields: ['email', 'status'],
            ordering: '-id',
            statuses: {},
        };
    },
    computed: {
        ...mapGetters('workspaces', ['workspaceCustomerId']),
        filtersFields() {
            let id = this.$route.params.id;

            if (id === 'speechki') {
                return { is_employee: true, status: undefined };
            }

            return {
                customer: this.$route.params.id,
                status: undefined,
            };
        },
    },
    watch: {
        workspaceCustomerId(customer) {
            let target = customer || 'speechki';

            this.$router.push({ name: 'customers-id-invites', params: { id: target } });
        },
    },
    async created() {
        this.statuses = await fetchCustomersInviteStatuses();
    },
    methods: {
        fetchCustomersInvites,
        refetch() {
            this.$refs.customerInvitesRes.fetch();
        },
    },
};
</script>

<style lang="scss" src="./CustomersInvitesPage.scss"></style>
